import Vue from 'vue'

/** 全局打开 Leo SOC助手（与 App 内 Host 单例 drawer 联动） */
export const leoOperatorAssistantBus = new Vue()

export function openLeoOperatorAssistant () {
  leoOperatorAssistantBus.$emit('open')
}

export function closeLeoOperatorAssistant () {
  leoOperatorAssistantBus.$emit('close')
}

const HIDDEN_ROUTE_NAMES = new Set([
  'login',
  'leoLogin',
  'leoPortal',
  'leoConsole',
  'leoStandaloneChat',
  'leoTrainingDecisionDeskMobile',
  'leoMembershipLogin',
  'leoMembershipRegister',
  '404',
  'privacyAgreement',
  'privacyAgreement1',
  'privacyAgreement2',
  'membershipRegister',
  'membershipLogin',
  'leoDeviceIntegrationPublic',
  'deviceCloudRuntimePublic',
  'xrrossSdkEngineerLab',
  'support-ticket-h5',
  'operation',
  'dataShow'
])

/** 是否在当前路由显示 Leo SOC助手 FAB */
export function routeShowsOperatorAssistant (route) {
  if (!route || !route.path) {
    return false
  }
  const name = String(route.name || '')
  if (HIDDEN_ROUTE_NAMES.has(name)) {
    return false
  }
  const p = String(route.path || '').toLowerCase()
  if (p === '/login' || p.startsWith('/membership/') || p.startsWith('/privacy')) {
    return false
  }
  if (p.startsWith('/leo/chat') || p.startsWith('/leo/login') || p === '/leo-portal') {
    return false
  }
  const inMain = (route.matched || []).some(r => r.name === 'main')
  if (inMain) {
    return true
  }
  if (p.startsWith('/leo-') || p.indexOf('ai-trustee') >= 0 || p.indexOf('portal-ops') >= 0) {
    return true
  }
  return false
}



// WEBPACK FOOTER //
// ./src/utils/leoOperatorAssistant.js